import { render, staticRenderFns } from "./languageSwitcher.vue?vue&type=template&id=5ea8de80&"
import script from "./languageSwitcher.vue?vue&type=script&lang=js&"
export * from "./languageSwitcher.vue?vue&type=script&lang=js&"
import style0 from "./languageSwitcher.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports